module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos-detail2.70ed9825.jpg";